import type { ListenerMiddlewareInstance } from "@reduxjs/toolkit";
import { userLoggedInPredicate } from "Data/Redux/Middleware/Predicates/User";
import type { AppState } from "Data/Redux/Reducers";
import { fetchHostnamesPageAction } from "Data/Redux/Slices/Hostnames";
import { pusherConnection } from "src/Pusher";

export const userLoggedInListener = (listenerMiddleware: ListenerMiddlewareInstance<AppState>) => {
	listenerMiddleware.startListening(
		{
			predicate: userLoggedInPredicate,
			effect: async (action, listenerApi) => {
				pusherConnection.initializeConnection();
				listenerApi.dispatch(fetchHostnamesPageAction());
			}
		}
	);
};
